import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrencySelector } from '../ducks/currency/selector';
import { getCurrencyThunk } from '../ducks/currency/thunk';
import { getConstantsSelector } from '../ducks/general/selector';
import { bigIntDecimalsDivision, bigIntFormat } from '../helpers/bignumber';
import { ThunkAppDispatch } from '../store';
import { ITransaction } from '../types/transaction';

interface IUseTransactionType {
  type?: ITransaction['type'];
  subtype?: ITransaction['subtype'];
  attachment?: ITransaction['attachment'];
}

interface IState {
  currencyTotal: string | null;
  transactionType: string | null;
}

const initialState: IState = {
  currencyTotal: null,
  transactionType: null,
};

export const useTransactionType = ({ type, subtype, attachment }: IUseTransactionType) => {
  const dispatch = useDispatch<ThunkAppDispatch>();
  const constants = useSelector(getConstantsSelector);
  const currency = useSelector(getCurrencySelector(attachment?.currency));
  const [state, setState] = useState<IState>(initialState);

  const getCurrency = useCallback(async () => {
    if (!attachment || !attachment?.currency) return;

    if (!currency) {
      dispatch(getCurrencyThunk(attachment.currency));
      return;
    }

    setState((prevState) => ({
      ...prevState,
      currencyTotal: attachment.units
        ? bigIntFormat(bigIntDecimalsDivision(attachment.units.toString(), currency.decimals ?? 1))
        : null,
    }));
  }, [attachment?.currency, attachment?.units, currency]);

  useEffect(() => {
    const transactionType =
      constants &&
      !!constants.transactionTypes &&
      // eslint-disable-next-line
      // @ts-ignore
      constants.transactionTypes[type] &&
      // eslint-disable-next-line
      // @ts-ignore
      constants.transactionTypes[type].subtypes[subtype].name;

    setState((state) => ({
      ...state,
      transactionType,
      currencyTotal: null,
    }));

    if (transactionType === 'CurrencyTransfer') {
      getCurrency();
    }
  }, [getCurrency, constants, type, subtype]);

  return {
    ...state,
    currencyCode: currency?.code,
    currencyDecimals: currency?.decimals,
  };
};
